module.exports = __webpack_public_path__ + "img/Cti12PapRbrSu0002A.9b941ead.jpg";